import { ReactNode } from 'react'
import { Card, CardContent, CardHeader } from '@mui/material'

interface DashboardCardProps {
  title: string
  subtitle: string
  headerColor:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'error'
    | 'info'
  children: ReactNode
}

export function DashboardCard({
  title,
  subtitle,
  headerColor,
  children,
}: DashboardCardProps) {
  return (
    <Card
      elevation={2}
      sx={{
        height: '100%',
      }}
    >
      <CardHeader
        title={title}
        subheader={subtitle}
        sx={{
          bgcolor: `${headerColor}.main`,
          color: 'white',
          '& .MuiCardHeader-subheader': {
            color: 'rgba(255, 255, 255, 0.7)',
          },
        }}
      />
      <CardContent sx={{ p: 3 }}>{children}</CardContent>
    </Card>
  )
}
